import React from "react";
import { Tabs, Tab, createMuiTheme, MuiThemeProvider } from "@material-ui/core";
import {
  Person,
  CardTravel,
  CreditCard,
  People,
  HeadsetMic,
  History,
} from "@material-ui/icons";
import { useHistory } from "react-router-dom";

const ProfileTabs = (props) => {
  const [value, setValue] = React.useState(props.url);

  const history = useHistory();

  const handleChange = (event, newValue) => {
    history.push(`/account/${newValue}`);
    setValue(newValue);
  };

  const muiTheme = createMuiTheme({
    overrides: {
      MuiTab: {
        root: {
          "&.Mui-selected": {
            backgroundColor: "none",
            borderBottom: "2px solid #6dd06d",
            borderColor: "#6dd06d",
          },
        },
      },
    },
  });

  return (
    <div
      className="row mx-auto w-100 h-auto bg-white  shadow-sm p-0 justify-content-center container"
      style={{ minHeight: 75, marginTop: "4rem", borderRadius: "13px" }}
    >
      <Tabs
        style={{ alignItems: "center", width: "100%" }}
        People
        value={value}
        onChange={handleChange}
        variant="scrollable"
      >
        <Tab
          style={{ minWidth: "16.5%" }}
          label={
            <span style={{ fontSize: 18 }} className="d-none d-md-flex">
              حساب کاربری
            </span>
          }
          icon={<Person style={{ fontSize: 20, minWidth: 0 }} />}
          value="profile"
        />
        <Tab
          value="travels"
          style={{ minWidth: "16.5%" }}
          className=""
          label={
            <span
              style={{ fontSize: 18, minWidth: 0 }}
              className="d-none d-md-flex"
            >
              سفرها
            </span>
          }
          icon={<CardTravel style={{ fontSize: 20, minWidth: 0 }} />}
        />{" "}
        <Tab
          value="transaction"
          style={{ minWidth: "16.5%" }}
          className=""
          label={
            <span style={{ fontSize: 18 }} className="d-none d-md-flex">
              تراکنش ها
            </span>
          }
          icon={<History style={{ fontSize: 20, minWidth: 0 }} />}
        />
        {/* <Tab
          value="recharge"
          className=""
          style={{ minWidth: "16.5%" }}
          label={
            <span style={{ fontSize: 18 }} className="d-none d-md-flex">
              افزایش اعتبار
            </span>
          }
          icon={<CreditCard style={{ fontSize: 20, minWidth: 0 }} />}
        /> */}
        {" "}
        <Tab
          value="passengers"
          style={{ minWidth: "16.5%" }}
          d
          className=""
          style={{ minWidth: "16.5%" }}
          label={
            <span style={{ fontSize: 18 }} className="d-none d-md-flex">
              لیست مسافران
            </span>
          }
          icon={<People style={{ fontSize: 20, minWidth: 0 }} />}
        />{" "}
        <Tab
          value="support"
          style={{ minWidth: "16.5%" }}
          className=""
          label={
            <span style={{ fontSize: 18 }} className="d-none d-md-flex">
              پشتیبانی
            </span>
          }
          icon={<HeadsetMic style={{ fontSize: 20, minWidth: 0 }} />}
        />{" "}
      </Tabs>
    </div>
  );
};

export default ProfileTabs;
